import { StepsAnswer } from "./styles";
import React from "react";
export default ({ howItWorksDetails, stepCount, step,isMobile }) => (
  <>
    <StepsAnswer
      className="stepAnswers"
      dangerouslySetInnerHTML={{
        __html: howItWorksDetails[`field_step_${stepCount}_a_${step}`]
      }}
    />

    {howItWorksDetails[`field_step_${stepCount}_image_${step}`] && (
      <div className="ant-row">
        <img
          src={howItWorksDetails[`field_step_${stepCount}_image_${isMobile? step+"_mobile":step}`]}
          className="howitWorksStepsImage"
          alt={`Step${step}`}
        />
      </div>
    )}
  </>
);
